import styled, { css } from 'styled-components';

export const OvCard = styled.div<{ $bg: string; $variant: 'front' | 'behind' }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 170px;
  min-height: 176px;
  border-radius: 3px;
  padding: 18px 12px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background: ${({ $bg }) => $bg};
  color: #000000;
  box-shadow:
    0 1px 1px rgba(0, 0, 0, 0.24),
    0 6px 10px -7px rgba(0, 0, 0, 0.5);
  transition:
    transform 0.16s ease,
    box-shadow 0.16s ease;

  ${({ $variant }) =>
    $variant === 'front'
      ? css`
          &:hover {
            transform: translateY(-3px) rotate(0deg) !important;
            box-shadow:
              0 2px 3px rgba(0, 0, 0, 0.22),
              0 11px 16px -9px rgba(0, 0, 0, 0.45);
          }
        `
      : css`
          box-shadow:
            0 1px 1px rgba(0, 0, 0, 0.2),
            3px 4px 9px -3px rgba(0, 0, 0, 0.4);
          &:hover {
            filter: brightness(1.03);
          }
        `}
`;

export const Magnet = styled.div<{ $color: string; $accent: string }>`
  position: absolute;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
  width: 19px;
  height: 19px;
  border-radius: 50%;
  z-index: 4;
  background: radial-gradient(
    circle at 35% 30%,
    #fff,
    ${({ $color }) => $color} 45%,
    ${({ $accent }) => $accent} 100%
  );
  box-shadow:
    0 3px 7px rgba(0, 0, 0, 0.45),
    inset 0 1px 2px rgba(255, 255, 255, 0.85),
    inset 0 -2px 4px rgba(0, 0, 0, 0.4);
`;

export const OvcLbl = styled.div`
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 4px;
`;

export const OvcQ = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const OvcWbTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  margin-bottom: 7px;
`;

export const OvcStars = styled.div`
  display: flex;
  font-size: 13px;
  letter-spacing: 1px;
  margin-bottom: 6px;
  color: #ffbc00;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
`;

export const OvcStarWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

export const OvcStarHalf = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  overflow: hidden;
`;

export const OvcFooter = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 6px;
`;

export const OvcBadges = styled.div`
  min-width: 0;
`;

export const OvcDate = styled.div`
  font-size: 9px;
  font-weight: 600;
  opacity: 0.7;
  text-align: right;
`;

export const OvcDraftTag = styled.div`
  position: absolute;
  top: -9px;
  right: -7px;
  background: #c89018;
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.6px;
  padding: 2px 8px;
  border-radius: 3px;
  transform: rotate(4deg);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 5;
`;

export const Pen = styled.span`
  display: inline-block;
  transform: scaleX(-1);
`;
